module.exports = __webpack_public_path__ + "static/media/Mentorship-3.c34f4203.jpg";